import React, { useEffect, useState } from "react";
import PanelHead from "../../../Panel/PanelHead";
import PanelBody from "../../../Panel/PanelBody";
import { FormSkypeGrop } from "./FormSkypeGrop";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";
import { LinearProgress } from "@mui/material";

export const AddPanelSkypeGrop = () => {
  const [loading, setLoader] = useState(true);
  const [Panels, setPanels] = useState([]);

  const get_panels = async () => {
    const { response } = await Helper.Get({
      url: api_Routes.Groups.PanelView,
      hasToken: true,
    });
    if (response) {
      setPanels(response);
      setLoader(false);
    }
  };

  useEffect(() => {
    setLoader(true);
    get_panels();
  }, []);

  return (
    <div>
      <PanelHead title="Add Teams Group" />
      <PanelBody
        content={
          loading ? (
            <LinearProgress />
          ) : (
            <FormSkypeGrop loading={loading} Panels={Panels} />
          )
        }
      />
    </div>
  );
};
